import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { Button } from 'components/UI';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { useStyles } from './styles';

const Page404: FC = () => {
  // Styling
  const logo = useSelector((state: AppState) => state.ui.themeBrandColor.logoUrl);
  const styles = useStyles();
  // Routing
  const history = useHistory();

  const handleHomeClick = () => {
    history.push('/');
  };
  // Translation
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.headersContainer}>
        <h1>{t('ViewFlow360')}</h1>
        <h2>{t('by')}</h2>
        <img style={{ maxHeight: '40px' }} src={`${logo}`} alt="logo" />
      </div>

      <div className={styles.content}>
        <Typography variant="h3" component="div">
          {`404 ${t('Page not found')}`}
        </Typography>
        <Typography variant="h5" component="div">
          {`${t('No match for')} ${history.location.pathname}`}
        </Typography>
        <Button labelKey={t('To Homepage')} type="button" onClick={handleHomeClick} />
      </div>
    </div>
  );
};

export default Page404;
